import { Stack, useRouter } from "expo-router";
import { useSetAtom } from "jotai/react";

import { FullLogo } from "@/blocks/FullLogo";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { APPLICATION_FLOW_DEFAULT_STEPS } from "@/domain/applications";
import {
  applicationCurrentStepAtom,
  applicationTotalStepsAtom,
} from "@/stores/atoms";

/**
 * Modal group layout for routes that uses modal presentation style.
 * Auth and registration protections are inherited from parent (authed)/_layout.tsx.
 */
export default function ModalGroupLayout() {
  const router = useRouter();
  const setApplicationCurrentStep = useSetAtom(applicationCurrentStepAtom);
  const setApplicationTotalSteps = useSetAtom(applicationTotalStepsAtom);

  const handleExit = () => {
    router.dismissTo("/(authed)");

    // Reset application flow step on exit
    setApplicationCurrentStep(1);
    setApplicationTotalSteps(APPLICATION_FLOW_DEFAULT_STEPS);
  };

  return (
    <Stack
      screenOptions={{
        animation: "slide_from_right",
        headerShown: true,
        header: () => (
          <VnBox className="bg-sidebar relative flex-row items-center justify-end px-5">
            <VnButton
              i18nKey="common:exit"
              variant="ghost"
              onPress={handleExit}
              className="my-4"
              textClassName="text-secondary"
            />
            <FullLogo className="text-secondary absolute left-1/2 top-1/2 h-5 -translate-x-1/2 -translate-y-1/2" />
          </VnBox>
        ),
      }}></Stack>
  );
}
